var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Loading } from 'element-ui';
import { Component } from 'vue-property-decorator';
import { summaries } from "../../helper/util";
import { EOrderSubType } from "../../enum/EUpperPurchase";
import PurchaseRefundForUpperSupService from '../../api/PurchaseRefundForUpperSupService';
import CommonService from '../../api/CommonService';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import OrderPicDialog from "./components/OrderPicDialog.vue";
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eOrderSubType = EOrderSubType;
        _this.tableHeight = document.documentElement.clientHeight - 290;
        _this.formData = {
            certificate_img: []
        };
        _this.data = [];
        _this.rowId = '';
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    Detail.prototype.created = function () {
        this.purchaseRefundForUpperSupService = PurchaseRefundForUpperSupService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getDetail();
        this.getGoodsTypeList();
    };
    Detail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Detail.prototype.search = function () {
        this.getDetail();
    };
    Detail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
            is_edit: 0,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        this.purchaseRefundForUpperSupService.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.data = data.detail;
            _this.formData = Object.assign({}, _this.formData, data, {
                certificate_img: JSON.parse(data.certificate_img).map(function (item) {
                    return {
                        url: item
                    };
                })
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_amount", "order_detail_uprice", "order_detail_money"];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        if (this.formData.order_sub_type == EOrderSubType['有单退货']) {
            sums[6] = '';
            sums[7] = '';
        }
        else {
            sums[5] = '';
            sums[6] = '';
        }
        return sums;
    };
    Detail.prototype.toOrderPic = function () {
        var dialog = this.$dialog(OrderPicDialog, {
            data: {
                pics: this.formData.certificate_img,
                pageType: 'see'
            }
        }, {
            title: "查看图片",
            width: 900,
            height: 550
        });
    };
    Detail = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
